import { PaginationERP, TableERP } from "@finanedi.es/storybook"
import {
  FetchDataRequestImpuestosDetalle,
  exportPerceptoresResumenDetalle180,
} from "api/AsientoContable.service"
import { MODELO_IMPUESTO, ModeloImpuestoType } from "api/Types/ModeloImpuesto"
import { TipoImpuestoModeloType } from "api/Types/TipoImpuestosModelosEnum"
import { TrimestreEnumType } from "api/Types/TrimestreEnum"
import { AxiosResponse } from "axios"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { extractFilename } from "common/utils/utils"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { MODELOS_IMPUESTOS } from "features/Contabilidad/pages/DetalleImpuestos/constants/modelosImpuestos"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import FilterMenuModeloAnual from "../FilterMenuModeloAnual"
import {
  RESUMEN_ANUAL_IMPUESTO_DETAIL_COLUMNS,
  renderHeader,
} from "../Modelo303/constant"

interface StateLocationProps {
  year: number
  modelo: ModeloImpuestoType
  periodo: TrimestreEnumType
  tipo: TipoImpuestoModeloType
}
const DetalleModelo180 = () => {
  const history = useHistory()
  const location = useLocation()
  const state = location.state as StateLocationProps
  const { t } = useTranslation()
  const { handleDirectDownloadExcel } = useDownloadFileContext()

  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })

  const fetchItems = useCallback(() => {
    return (queryState: FetchDataRequestImpuestosDetalle) =>
      MODELOS_IMPUESTOS()[MODELO_IMPUESTO.MODELO_180].serviceResumenDetalle({
        ...queryState,
        Anyo: state.year,
      })
  }, [state.year])

  const { items, isLoading, setServiceQuery } = useFilterMenu({
    serviceCall: fetchItems,
  })

  /** PAGINACIÓN DEL LADO CLIENTE  */
  const paginatedItems = useMemo(() => {
    const allItems = items
    const startIndex = pagination.skipCount
    const endIndex = startIndex + pagination.itemsPerPage
    return allItems.slice(startIndex, endIndex)
  }, [items, pagination])

  const handleKeywordChange = () => {
    setPagination((prev) => ({ ...prev, skipCount: 0 }))
  }

  const goBack = () => {
    history.goBack()
  }

  const onSuccessDowloadFile = (
    response: AxiosResponse,
    headers: Record<string, string>
  ) => {
    const nameFile = extractFilename(headers["content-disposition"])
    handleDirectDownloadExcel(response, nameFile)
  }

  const requestHandleDownloadXml = async (): Promise<void> => {
    try {
      const data = await MODELOS_IMPUESTOS()[
        MODELO_IMPUESTO.MODELO_180
      ].serviceExportResumenDetalle({
        Anyo: state.year,
      })
      onSuccessDowloadFile(data, data.headers)
      notification.success({
        body: `${t("taxSummary.detail.msg.downloadSuccess")}`,
      })
    } catch (error) {
      notification.errorServidor({
        body: `${t("taxSummary.detail.msg.downloadError")}`,
      })
    }
  }

  const requestHandleDownloadPerceptoresXml = async (): Promise<void> => {
    try {
      const data = await exportPerceptoresResumenDetalle180({
        Anyo: state.year,
      })
      onSuccessDowloadFile(data, data.headers)
      notification.success({
        body: `${t("taxSummary.detail.msg.downloadSuccess")}`,
      })
    } catch (error) {
      notification.errorServidor({
        body: `${t("taxSummary.detail.msg.downloadError")}`,
      })
    }
  }

  useEffect(() => {
    setPagination((prev) => ({ ...prev, skipCount: 0 }))
  }, [pagination.itemsPerPage])

  return (
    <>
      <div className='tw-w-full tw-h-[70px] tw-flex tw-flex-row tw-px-8 tw-py-3 tw-items-center tw-justify-between tw-bg-white tw-border-b tw-border-gray-200'>
        {renderHeader({
          t,
          trimester: "",
          year: state.year,
          goBack,
          modelNumber: state.modelo,
          type: state.tipo,
        })}
        <FilterMenuModeloAnual
          serviceQuery={setServiceQuery}
          resetPagination={handleKeywordChange}
          handleDownload={requestHandleDownloadXml}
          handleDownloadPerceptores={requestHandleDownloadPerceptoresXml}
        />
      </div>
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-70px)] tw-relative '>
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            columns={RESUMEN_ANUAL_IMPUESTO_DETAIL_COLUMNS(
              t,
              MODELO_IMPUESTO.MODELO_180
            )}
            className='tw-h-full'
            value={paginatedItems}
            columnResizeMode='expand'
            lazy
            loading={isLoading}
            dataKey='id'
            showGridlines
            size='small'
            emptyMessage={t("primeReact.table.emptyMessage")}
          />
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={items?.length ?? 0}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            setPagination={setPagination}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            resetScroll={() => {}}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      </div>
    </>
  )
}

export default DetalleModelo180
